import api from '@/api'
// eslint-disable-next-line
import axios from '@/axios'
import qs from 'qs';

const path = '/Personal'

export default {
  get (obj) {
    var urlrequest = api.url + path;
    console.log('get ', urlrequest, obj);
    return axios.get(`${urlrequest}/Get`,{
      params:obj
    })
  },
  getPersonal(obj) {
    console.log('Find', obj)
    return axios.post(`${api.url + path}/Find`,  obj)
  },
  getLista(obj, config = {}) {
    console.log("getLista");
    return axios.get(`${api.url + path}/GetLista`, {
      ...config,
      params: obj
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/personal/index.js